(() => {
  if (window.ObjectivColorMode) return;
  const key = 'objectiv-color-mode';
  const root = document.documentElement;
  const system = matchMedia('(prefers-color-scheme: dark)');
  const readPreference = () => {
    try {
      const value = localStorage.getItem(key);
      return value === 'light' || value === 'dark' ? value : null;
    } catch (_) { return undefined; }
  };
  let preference = readPreference();
  let paintFrame;
  const syncButtons = () => {
    const dark = root.dataset.colorMode === 'dark';
    document.querySelectorAll('[data-color-mode-toggle]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-pressed', String(dark));
      button.title = dark ? button.dataset.lightLabel : button.dataset.darkLabel;
    });
    document.querySelectorAll('[data-color-mode-picker]').forEach(picker => {
      picker.hidden = false;
      picker.querySelectorAll('[data-color-mode-input]').forEach(input => {
        input.checked = input.value === root.dataset.colorMode;
      });
    });
  };
  const apply = () => {
    const mode = preference || (system.matches ? 'dark' : 'light');
    if (root.dataset.colorMode !== mode) {
      cancelAnimationFrame(paintFrame);
      root.dataset.colorModeSwitching = '';
      paintFrame = requestAnimationFrame(() => {
        paintFrame = requestAnimationFrame(() => { delete root.dataset.colorModeSwitching; });
      });
    }
    root.dataset.colorMode = mode;
    root.style.colorScheme = mode;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = mode === 'dark' ? '#171918' : '#E5E3DE';
    syncButtons();
    document.dispatchEvent(new CustomEvent('objectiv:color-mode-change', { detail: { mode } }));
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-color-mode-toggle]')) return;
    preference = root.dataset.colorMode === 'dark' ? 'light' : 'dark';
    try { localStorage.setItem(key, preference); } catch (_) {}
    apply();
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-color-mode-input]')) return;
    preference = event.target.value;
    try { localStorage.setItem(key, preference); } catch (_) {}
    apply();
  });
  // Safari does not focus radios on label taps. Keep focus inside the drawer
  // before its focus-out handler checks whether the user has left the menu.
  document.addEventListener('mousedown', event => {
    const label = event.target.closest('[data-color-mode-picker] label');
    const input = label?.querySelector('[data-color-mode-input]');
    if (!input) return;
    event.preventDefault();
    input.focus({ preventScroll: true });
  });
  system.addEventListener('change', () => { if (!preference) apply(); });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    const saved = readPreference();
    if (saved !== undefined) preference = saved;
    apply();
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    const saved = readPreference();
    if (saved !== undefined) preference = saved;
    apply();
  });
  document.addEventListener('shopify:section:load', syncButtons);
  window.ObjectivColorMode = { syncButtons };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
})();
